import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Router from "./routers";
import reportWebVitals from "./reportWebVitals";
import initI18n from "locales/i18n";
import { Device } from "common/device";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

if (window.__DEVICE__?.isDarkMode) {
	document.documentElement.classList.add("dark");
} else {
	document.documentElement.classList.remove("dark");
}
initI18n();

root.render(
  // <React.StrictMode>
  <Router />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
